import React, { useEffect, useState } from 'react';
import { debounce } from 'lodash-es';
import styled, { css } from '../../styled';
import Text from '../text';
import { useIsMobile, supportsPassive } from '../../utils';
const Wrapper = styled.div `
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;
const ItemWrapper = styled.div `
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-left: 0.0625rem solid ${({ theme }) => theme.colors.INK_300};
  white-space: pre-line;

  :hover {
    cursor: pointer;
  }
  &:not(:last-child) {
    padding-bottom: 1rem;
  }
  & > * {
    padding-left: 1.5rem;
    box-sizing: border-box;
  }

  & > :first-child{
    padding-bottom: 0.25rem;
  }

  ${({ active }) => active &&
    css `
      & > :first-child {
        padding-left: 1.3125rem;
        border-left: 0.1875rem solid ${({ theme }) => theme.colors.INK_800};
        color: ${({ theme }) => theme.colors.INK_800};
        font-weight: 500;
      }
    `}

  ${({ active }) => !active &&
    css `
      &:hover > :first-child {
        padding-left: 1.3125rem;
        border-left: 0.1875rem solid ${({ theme }) => theme.colors.PRIMARY_300};
        color: ${({ theme }) => theme.colors.PRIMARY_600};
      }
      &:active > :first-child {
        padding-left: 1.3125rem;
        border-left: 0.1875rem solid ${({ theme }) => theme.colors.INK_800};
        color: ${({ theme }) => theme.colors.INK_800};
        font-weight: 500;
    `}
  }
`;
const TextWrapper = styled.div `
  display: inline-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const Item = ({ lang, title, content, defaultMessage, target, active, onClick, setScrollTarget, scrollOffset, scrollbarWrapper, setScrollingToBottom, noContent, }) => {
    return (React.createElement(ItemWrapper, { active: active, onClick: () => {
            onClick();
            if (target && target.current) {
                const maxScrollHeight = scrollbarWrapper.scrollHeight - scrollbarWrapper.clientHeight;
                if (target.current.offsetTop - scrollOffset < maxScrollHeight)
                    setScrollTarget([
                        target.current.offsetTop - scrollOffset,
                        target.current.offsetTop + target.current.clientHeight,
                    ]);
                else {
                    setScrollingToBottom(true);
                }
                scrollbarWrapper.scrollTo({
                    behavior: 'smooth',
                    top: target.current.offsetTop - scrollOffset,
                });
            }
        } },
        React.createElement(Text, { fontType: "Body", lang: lang, color: "INK_600" }, title),
        React.createElement(Text, { fontType: "Caption", lang: lang, color: content ? 'INK_500' : 'INK_400' },
            React.createElement(TextWrapper, null, !noContent && (content || defaultMessage)))));
};
const AnchorLink = ({ lang, items, defaultMessage, scrollOffset = 24, scrollbarWrapper, }) => {
    const isMobile = useIsMobile();
    const [activeKey, setActiveKey] = useState(0);
    const [scrollTarget, setScrollTarget] = useState([-1, -1]);
    const [scrollingToBottom, setScrollingToBottom] = useState(false);
    // listen to scroll event and set active key
    useEffect(() => {
        const listenToScroll = debounce(() => {
            const winScroll = scrollbarWrapper.scrollTop;
            const maxScrollHeight = scrollbarWrapper.scrollHeight - scrollbarWrapper.clientHeight;
            // reach bottom
            if (winScroll === maxScrollHeight && scrollingToBottom) {
                setScrollingToBottom(false);
                setScrollTarget([-1, -1]);
            }
            // changeable
            else if (scrollTarget[0] === -1 && !scrollingToBottom) {
                items.forEach((item, index) => {
                    const { target } = item;
                    if (target &&
                        target.current &&
                        winScroll >= target.current.offsetTop - scrollOffset &&
                        winScroll <=
                            target.current.offsetTop +
                                target.current.offsetHeight -
                                scrollOffset)
                        setActiveKey(index);
                });
            }
            // reach target
            else if (winScroll >= scrollTarget[0] &&
                winScroll <= scrollTarget[1] &&
                !scrollingToBottom)
                setScrollTarget([-1, -1]);
        });
        const scrollListener = scrollbarWrapper.tagName === 'HTML' ? window : scrollbarWrapper;
        scrollListener.addEventListener('scroll', listenToScroll, supportsPassive ? { passive: true } : false);
        return () => scrollListener.removeEventListener('scroll', listenToScroll);
    }, [items, scrollOffset, scrollTarget, scrollbarWrapper, scrollingToBottom]);
    return !isMobile ? (React.createElement(Wrapper, null, items.map((item, index) => (React.createElement(Item, Object.assign({ key: item.title }, item, { lang: lang, defaultMessage: defaultMessage, active: activeKey === index, onClick: () => setActiveKey(index), setScrollTarget: setScrollTarget, scrollOffset: scrollOffset, scrollbarWrapper: scrollbarWrapper, setScrollingToBottom: setScrollingToBottom })))))) : null;
};
export default AnchorLink;
//# sourceMappingURL=AnchorLink.js.map